import { StartConfiguration as Admin } from './AdminStartConfiguration';
import { StartConfiguration as Learning } from './LearningStartConfiguration';

export const StartConfiguration = {
  Admin,
  Learning,
};
